import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'schools.success.heading',
		defaultMessage: 'Success Stories',
		description: 'Calm Schools Success Stories heading text',
	},
	button: {
		id: 'schools.success.button',
		defaultMessage: 'Join the movement',
		description: 'Calm Schools Success Stories call to action text',
	},
});
